import { forwardRef, useMemo } from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  enabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => unknown;
};

export const ToolbarButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {

  const Button = useMemo(() => styled.button(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    width: '32px',
    height: '34px',

    color: theme.palette.gray.dark1,
    borderRadius: '4px',

    ':last-of-type': {
      marginBottom: 0,
    },

    '&:hover': {
      background: theme.palette.gray.light2,
      color: theme.palette.black.light1,
    },

    '&:disabled, &:disabled:hover': {
      color: theme.palette.gray.light1,
      background: theme.palette.secondary.main,
      cursor: 'default',
    },

    ...(props.enabled ? {
      background: theme.palette.gray.dark1,
      color: theme.palette.white.main,

      '&:hover': {
        background: theme.palette.gray.dark1,
        color: theme.palette.white.main,
      },
    } : {}),

  })), [props.enabled]);

  return (
    <Button
      ref={ref}
      disabled={props.disabled}
      onMouseDown={e => e.preventDefault()}
      onClick={props.onClick}>
      {props.children}
    </Button>
  );
});